module.exports = __webpack_public_path__ + "img/coal.09cc7c43.png";